import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-katni-fide-chess-tournament',
  templateUrl: './katni-fide-chess-tournament.component.html',
  styleUrls: ['./katni-fide-chess-tournament.component.scss']
})
export class KatniFideChessTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
